import { wealthProApi } from "../../redux/api";

const assetReturnApiEndpoints = wealthProApi.enhanceEndpoints({

}).injectEndpoints({
    endpoints: (build) => ({
        fetchAssetReturnsForGrid: build.query({
            query: ({page, limit, sort, filterModel}) => ({
                url: 'api/assets/assetreturn/grid',
                method: "POST",
                body: {
                    page,
                    limit,
                    sort,
                    filterModel
                }
            })
        }),
        patchAssetReturn: build.mutation({
            query: ({assetId, operations}) => ({
                url: `api/assets/assetreturn/${assetId}`,
                method: "PATCH",
                body: operations
            })
        })
    })
});

export const {
    useLazyFetchAssetReturnsForGridQuery,
    usePatchAssetReturnMutation
} = assetReturnApiEndpoints;